import type { Stop } from '#domain/model/Stop.ts';

export const filterStopInSearch = (searchText: string, stop: Stop | undefined): boolean => {
    if (!stop) {
        return false;
    }

    return [stop.name, stop.location.city, stop.location.zipCode, stop.location.street]
        .filter(Boolean)
        .some(value => value?.toLowerCase().includes(searchText));
};
